import styled from 'styled-components'
import { SpacingType } from './Navigation'

export const StyledNavigation = styled.div`
  width: 100%;
`

export const NavigationButton = styled.button<{ active?: boolean; spacing?: SpacingType }>`
  background-color: ${props => (props.active ? props.theme.colors.white[500] : 'transparent')};
  padding: ${props => props.theme.spacing.default} ${props => props.theme.spacing[props.spacing as string]};
  color: ${props => (props.active ? props.theme.colors.secondary[500] : props.theme.colors.black[500])};
  border-radius: ${props => props.theme.radius.normal};

  @media screen and (max-width: 768px) {
    display: none;
  }
`

export const ButtonContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-right: 1rem;
    color: ${props => props.theme.colors.info[500]};
  }
`
